'use client';

import classNames from 'classnames';
import { ComponentProps, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import logTripPlannerCTAClicked from '@alltrails/amplitude/events/logTripPlannerCTAClicked';
import Button from '@alltrails/denali/components/Button';
import DrawPath from '@alltrails/denali/icons/DrawPath';
import PlaceTrail from '@alltrails/denali/icons/PlaceTrail';
import Sparkle from '@alltrails/denali/icons/Sparkle';
import { useIsTripPlannerEntryPointVisible } from '@alltrails/layout/hooks/tripPlannerAvailability';
import styles from './HomeHeroCtas.module.scss';

type HomeHeroCtasProps = {
  className?: string;
  darkTheme?: boolean;
  hideNearbyTrails?: boolean;
  variant?: ComponentProps<typeof Button>['variant'];
};

/**
 * https://www.figma.com/design/jRyJm5tO66lHSa0E8PSox2/H2--26-Trip-planner?node-id=2704-84522&m=dev
 */
const HomeHeroCtas = ({ className, darkTheme, hideNearbyTrails = false, variant }: HomeHeroCtasProps) => {
  const isTripPlannerVisible = useIsTripPlannerEntryPointVisible();

  const onCreateTripClick = useCallback(() => {
    // TODO(DATA-6308): pass entry_point once a homepage CardLocation value exists.
    logTripPlannerCTAClicked({});
  }, []);

  return (
    <div className={classNames(styles.container, className)} {...(darkTheme ? { ['data-at-theme-colors']: 'dark' } : {})}>
      {isTripPlannerVisible && (
        <Button
          className={styles.cta}
          icon={{ Component: Sparkle }}
          linkInfo={{ href: '/trip-planner' }}
          onClick={onCreateTripClick}
          size="md"
          text="Create a trip" // trip planner only available to en-US
          variant={variant}
        />
      )}
      <Button
        className={styles.cta}
        icon={{ Component: DrawPath }}
        linkInfo={{ href: '/explore/custom-routes/new?trigger=home' }}
        size="md"
        text={<FormattedMessage defaultMessage="Build custom route" />}
        variant={variant}
      />
      {!hideNearbyTrails && (
        <Button
          className={styles.cta}
          icon={{ Component: PlaceTrail }}
          linkInfo={{ href: '/explore' }}
          size="md"
          text={<FormattedMessage defaultMessage="Nearby trails" />}
          variant={variant}
        />
      )}
    </div>
  );
};

export default HomeHeroCtas;
